import { getAuthorization } from 'controllers/controller';
import { getJobSummaryService } from 'services/dashboard/getJobSummary';

export const getJobSummary = async (jobId) => {
  const authorization = getAuthorization();

  const { data } = await getJobSummaryService(authorization, jobId);

  return data.response;
};
